import request from '../request'

export interface GroupStatisticsDataType {
    total_members_count: number
    active_members_count: number
    join_members_count: number
    leave_members_count: number
}

export const getGroupStatisticsData = (args: {
    groupId: string
    days: number
}): Promise<GroupStatisticsDataType> => {
    return request.get(
        `/wechaty/group/statistics?group_id=${args.groupId}&days=${args.days}`
    )
}

interface GroupWordCloudDataType {
    [key: string]: number
}

export const getGroupWordCloudData = (args: {
    groupId: string
    days: number
}): Promise<{ topn_words_frequency: GroupWordCloudDataType[] }> => {
    return request.get(
        `/wechaty/group/word_frequency?group_id=${args.groupId}&days=${args.days}`
    )
}
